import Vue from 'vue'
import ToastVue from './toast'
const toString = Object.prototype.toString

/**
 * @param {String|Object} options
 * @property {String} options.message   内容
 * @property {Number} options.duration  持续显示的时间 默认1500毫秒
 */
function toast(options) {
  if (toString.call(options) === '[object String]') {
    return toast.call(Toast, { message: options })
  }
  if (toString.call(options) !== '[object Object]') return null

  const defaultOptions = {
    message: '',
    duration: 1500
  }
  options = Object.assign({}, defaultOptions, options)
  if (!Toast.instance) {
    const ToastConstructor = Vue.extend(ToastVue)
    Toast.instance = new ToastConstructor({ el: document.createElement('div') })
    document.body.appendChild(Toast.instance.$el)
  }
  Toast.instance.message = options.message

  setTimeout(() => {
    const toastWidth = Toast.instance.$refs.shadow.clientWidth
    Toast.instance.$refs.toast.style.width = `${toastWidth + 4}px` // 4px兼容部分机型，不换行
    Toast.instance.visible = true
    Toast.resetTimer(options.duration)
  }, 0)
}
const Toast = {
  // 是否挂载
  instance: null,
  timer: null,
  resetTimer(duration) {
    if (this.timer) {
      clearTimeout(this.timer)
      this.timer = null
    }
    this.timer = setTimeout(this.close, duration)
  },
  close: () => {
    Toast.instance.visible = false
  },
  install() {
    Object.defineProperty(Vue.prototype, '$toast', { get: () => toast })
  }
}
export { toast }
export default Toast
